import axios from "axios";

export const GET_POSSIBLE_CUSTOMERS = "/invoiceOrders/getPossibleCustomersList";
export const EDIT_INVOICE_ORDER_WITH_CUSTOMER_DATA = "/invoiceOrders/editInvoiceOrder";

export function getPossibleCustomersList(data, cancellationHandlers) {
  return axios.post(GET_POSSIBLE_CUSTOMERS, data, cancellationHandlers);
}

export function editInvoiceOrderWithCustomerData(data) {
  return axios.post(EDIT_INVOICE_ORDER_WITH_CUSTOMER_DATA, data);
}
